import React from "react";
import "./StarBorder.css"; // Ensure correct import
import { Link } from "react-router-dom"; // If using React Router

const StarBorder = ({
  as: Component = "button",
  className = "",
  color = "white",
  speed = "6s",
  link = "",
  children,
  ...rest
}) => {
  const isButton = Component === "button";

  return isButton && link ? (
    <Link
      to={link}
      className={`star-border-container ${className}`} // ✅ Ensures custom CSS applies
      {...rest}
    >
      <div
        className="border-gradient-bottom"
        style={{
          background: `radial-gradient(circle, ${color}, transparent 10%)`,
          animationDuration: speed,
        }}
      ></div>
      <div
        className="border-gradient-top"
        style={{
          background: `radial-gradient(circle, ${color}, transparent 10%)`,
          animationDuration: speed,
        }}
      ></div>
      <div className={`inner-content ${className} `}{...rest}>{children}</div>
    </Link>
  ) : (
    <Component className={`star-border-container ${className}`} {...rest}>
      <div
        className="border-gradient-bottom"
        style={{
          background: `radial-gradient(circle, ${color}, transparent 10%)`,
          animationDuration: speed,
        }}
      ></div>
      <div
        className="border-gradient-top"
        style={{
          background: `radial-gradient(circle, ${color}, transparent 10%)`,
          animationDuration: speed,
        }}
      ></div>
      <div className="inner-content">{children}</div>
    </Component>
  );
};

export default StarBorder;
